<script lang="ts">
  import { intersection } from "@opera-gx/common/src/actions/intersection";
  import { writable } from "svelte/store";

  import ShowMore from "../../components/ShowMore/ShowMore.svelte";
  import WatchSectionYtPlayer from "./WatchSectionYtPlayer.svelte";

  export let infinite = false;
  export let items;

  export let section_title: string;
  export let key = "";

  let showMore = writable(false);
  let headerIntersecting = false;
  let showMoreIntersecting = false;
  const limit = 2;
</script>

<style lang="postcss">
  .section-title {
    transition:
      opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1),
      transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    opacity: 0;
    transform: translateX(-15px);

    &.show {
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>

{#if items}
  <section
    id={key !== "" ? `gx-section_${key}` : null}
    class="pl-left pr-right flex flex-col gap-4">
    <header
      class="flex flex-col gap-1"
      use:intersection={{
        handler: (entries) => {
          if (!entries.some(({ isIntersecting }) => isIntersecting)) {
            headerIntersecting = false;
            return;
          }

          if (entries.some(({ intersectionRatio }) => intersectionRatio >= 0.05)) {
            headerIntersecting = true;
            return;
          }
        },
        rootMargin: "100% 0px 0px 0px",
        threshold: [0, 0.05],
      }}>
      <h2
        class="section-title text-lg font-semibold leading-5"
        style="color: hsl(var(--color-gxm-text-on-wallpaper));"
        class:show={headerIntersecting}>
        {section_title || ""}
      </h2>
    </header>

    {#if items.length > 0}
      <div class="box-border grid grid-cols-1 gap-4 sm:grid-cols-2">
        {#each $showMore ? items : items.slice(0, limit) as video, index}
          {#if video?.trailer}
            <WatchSectionYtPlayer url={video?.trailer} title={video?.title} {index} />
          {/if}
        {/each}
      </div>

      {#if items.length > limit && !infinite}
        <ShowMore {showMore} {showMoreIntersecting} {section_title} />
      {/if}
    {/if}
  </section>
{/if}
